module.exports = __webpack_public_path__ + "img/rule_tab2.be25d80a.png";